(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jfab-luminary-product"]) return;
  try {
    
  function initializeLuminaryProduct(root) {
    if (root.dataset.luminaryInitialized) return;
    const source = root.querySelector('[data-luminary-data]');
    if (!source) return;
    const data = JSON.parse(source.textContent);
    const form = root.querySelector('form');
    const selectors = Array.from(root.querySelectorAll('[data-luminary-option]'));
    const native = root.querySelector('[data-luminary-id]');
    const button = root.querySelector('[data-luminary-submit]');
    const price = root.querySelector('[data-luminary-price]');
    const sku = root.querySelector('[data-luminary-sku]');
    const address = root.querySelector('[data-luminary-address]');
    const galleryItems = Array.from(root.querySelectorAll('[data-luminary-media]'));
    if (!form || !native || !button || !selectors.length) return;
    const update = (changeUrl) => {
      const choices = selectors.map(select => select.value);
      const variant = data.variants.find(candidate => candidate.options.every((option,index) => option === choices[index]));
      button.disabled = !variant || !variant.available;
      button.textContent = variant && variant.available ? data.add : data.unavailable;
      if (!variant) {
        native.value = '';
        sku.textContent = '';
        galleryItems.forEach(item => { item.hidden = false; });
        return;
      }
      const matchingMedia = variant.mediaId ? galleryItems.find(item => item.dataset.luminaryMedia === String(variant.mediaId)) : null;
      galleryItems.forEach(item => { item.hidden = matchingMedia ? item !== matchingMedia : false; });
      native.value = String(variant.id);
      price.textContent = variant.price;
      sku.textContent = variant.sku;
      if (changeUrl) {const url = new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);}
    };
    selectors.forEach(select => select.addEventListener('change',() => update(true)));
    if(address){
      const validateAddress = () => address.setCustomValidity(address.value.trim() ? '' : data.addressError);
      address.addEventListener('input',validateAddress);
      form.addEventListener('submit',event => {address.value=address.value.trim();validateAddress();if(!address.checkValidity()){event.preventDefault();address.reportValidity();}});
    }
    root.querySelector('[data-luminary-native]').hidden = true;
    root.querySelector('[data-luminary-options]').hidden = false;
    root.dataset.luminaryInitialized='true';
    update(false);
  }
  document.querySelectorAll('[data-luminary-product]').forEach(initializeLuminaryProduct);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-luminary-product]').forEach(initializeLuminaryProduct));

  } catch(e) { console.error(e); }
})();
})();
